import React, { useState } from 'react';
import { Modal, Form, Checkbox, Input, Button, message } from 'antd';
import { SaveOutlined, CloseOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { holidaysApi } from '../../../utils/api';
import { scrollToFirstError } from '../../../utils/formHelpers';

const { TextArea } = Input;

const WEEK_DAYS = [
  { label: 'شنبه', value: 0 },
  { label: 'یکشنبه', value: 1 },
  { label: 'دوشنبه', value: 2 },
  { label: 'سه‌شنبه', value: 3 },
  { label: 'چهارشنبه', value: 4 },
  { label: 'پنج‌شنبه', value: 5 },
  { label: 'جمعه', value: 6 },
];

const MarkDefaultHolidaysModal = ({ visible, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedDays, setSelectedDays] = useState([]);

  const handleDayChange = (dayValue, checked) => {
    setSelectedDays((prev) =>
      checked ? [...prev, dayValue] : prev.filter((d) => d !== dayValue),
    );
  };

  const submitToApi = async (occassion) => {
    setLoading(true);
    try {
      await holidaysApi.markHolidayStore({
        office_holiday_days: selectedDays,
        occassion: occassion || '',
      });
      message.success('تعطیلات پیش‌فرض با موفقیت ثبت شد');
      form.resetFields();
      setSelectedDays([]);
      onSuccess?.();
      onClose();
    } catch (error) {
      console.error(error);
      message.error('خطا در ثبت تعطیلات پیش‌فرض');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      const validatedValues = await form.validateFields();
      if (selectedDays.length === 0) {
        message.warning('لطفاً حداقل یک روز هفته را انتخاب کنید');
        return;
      }

      Modal.confirm({
        title: (
          <span style={{ fontFamily: 'CustomFont', fontWeight: 600, fontSize: 16 }}>
            آیا مطمئن هستید که می‌خواهید روزهای انتخابی را به‌عنوان تعطیل علامت بزنید؟
          </span>
        ),
        icon: <ExclamationCircleOutlined style={{ color: '#fa8c16', fontSize: 28 }} />,
        content: (
          <p style={{ fontFamily: 'CustomFont', textAlign: 'center', color: '#595959', marginBottom: 0 }}>
            توجه: این کار همه روزهای انتخابی در طول سال را به‌عنوان تعطیل علامت خواهد زد. شما باید به‌صورت دستی آنها را حذف کنید.
          </p>
        ),
        centered: true,
        okText: 'بله، ذخیره کن!',
        cancelText: 'لغو',
        okButtonProps: {
          style: { fontFamily: 'CustomFont', backgroundColor: '#16a34a', borderColor: '#16a34a' },
        },
        cancelButtonProps: {
          style: { fontFamily: 'CustomFont', borderColor: '#d9d9d9', color: '#595959' },
        },
        onOk: () => submitToApi(validatedValues.occasion),
      });
    } catch (error) {
      if (error.errorFields?.length > 0) {
        scrollToFirstError(form);
      }
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setSelectedDays([]);
    onClose();
  };

  return (
    <Modal
      title={<span style={{ fontFamily: 'CustomFont' }}>علامت گذاری تعطیلات</span>}
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
      style={{ fontFamily: 'CustomFont' }}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        style={{ fontFamily: 'CustomFont' }}
      >
        <Form.Item
          label={
            <span style={{ fontFamily: 'CustomFont' }}>
              علامت گذاری روزها برای تعطیلات پیش فرض سال جاری
            </span>
          }
        >
          <div className="flex flex-wrap gap-4">
            {WEEK_DAYS.map((day) => (
              <Checkbox
                key={day.value}
                checked={selectedDays.includes(day.value)}
                onChange={(e) => handleDayChange(day.value, e.target.checked)}
                style={{ fontFamily: 'CustomFont' }}
              >
                {day.label}
              </Checkbox>
            ))}
          </div>
        </Form.Item>

        <Form.Item
          label={<span style={{ fontFamily: 'CustomFont' }}>مناسبت</span>}
          name="occasion"
        >
          <TextArea
            rows={2}
            placeholder="مناسبت"
            style={{ fontFamily: 'CustomFont' }}
          />
        </Form.Item>

        <div className="flex items-center justify-end gap-4 mt-6">
          <Button
            icon={<CloseOutlined />}
            onClick={handleCancel}
            style={{ fontFamily: 'CustomFont' }}
          >
            لغو
          </Button>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            htmlType="submit"
            loading={loading}
            className="bg-green-600 hover:bg-green-700 border-green-600"
            style={{ fontFamily: 'CustomFont' }}
          >
            ذخیره
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default MarkDefaultHolidaysModal;
